<script>
    import axios from 'axios'
    import { Drag, Drop } from 'vue-drag-drop';
    import findIndex from "lodash/findIndex";
    import {inputBodyClickListener} from '../../../../lib/body-click-listener-helper'
    import AppMixin from './../../../../mixins/AppMixin'
    import {get, isNumber} from 'lodash'
    import {nextTick} from "vue";
    import {Listeners} from "../../../../constants/listeners";
    import {store} from "../../store";

    export default {
        mixins: [AppMixin],
        props: {
            model: Object,
            onNodeRightClick: Function,
            onNodeClick: Function,
            filter: String,
            tree: Object,
        },
        data() {
            return {
                isDragOver: false,
                isHover: false,
                isEdit: false,
                clickListener: inputBodyClickListener(this, 'editInput', 'isEdit'),
                events: {},
                name: null,
                delay: 700,
                clicks: 0,
                timer: null,
                store: store,
                dragFolderId: null,
            }
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getConstants() {
                return this.store.getters.constants();
            },
            getNodeIds() {
                return this.store.getters.nodeIds();
            },
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getSelectNodes() {
                return this.store.getters.selectNodes();
            },
            getSelectContextNode() {
                return this.store.getters.selectContextNode();
            },
            isContext() {
                return this.store.getters.isContext();
            },
            getSetting() {
                return this.store.getters.setting();
            },
            getSettingViewCountWeight() {
                return this.store.getters.settingViewCountWeight();
            },
            isFolder(){
                return this.model.has_children;
            },
            isOpen(){
                return this.model.state.open;
            },
            isLock(){
                return this.model.lock;
            },
            anchorClasses () {
                return [
                    {'tree-node': true},
                    {'tree-node-hovered': this.isHover || (this.isContext && this.getSelectContextNode.id === this.model.id)},
                    {'tree-node-select': this.isNodeSelect()},
                    {'tree-node-drag-over': this.isDragOver},
                ]
            },
            folderClasses(){
                return [
                    {'fa fa-folder-o': !this.isOpen},
                    {'fa fa-folder-open-o': this.isOpen},
                ]
            },
            chevronClasses(){
                return [
                    {'fa fa-chevron-right': !this.isOpen},
                    {'fa fa-chevron-down': this.isOpen},
                ]
            },
            isNotFolderClasses(){
                return [
                    {'fa fa-trash-o': this.model.id === -2},
                    {'fa fa-archive': this.model.id === -1},
                    {'fa fa-file-o': this.model.id > 0},
                ]
            },
            selectedDragItemsCount(){
                return this.getSelectNodes.length;
            },
            isDraggable(){
                switch (this.model.id) {
                    case 0:
                    case -1:
                    case -2:
                        return false;
                    default:
                        return true;
                }
            },
            apiUrl(){
                return this.$config.API_URL + '/clustering/node/' + this.getUid
            },

            labelInfo(){

                let result = [];
                for (let p in this.getSetting.view.treeNodeName) {
                    if(!this.getSetting.view.treeNodeName.hasOwnProperty(p)) {
                        continue;
                    }

                    if(this.getSetting.view.treeNodeName[p].enabled){
                        const value = get(this.model, p);

                        result.push({
                            key: p,
                            color: this.getSetting.view.treeNodeName[p].color,
                            background: this.getSetting.view.treeNodeName[p].background,
                            value: isNumber(value) ? value.formatMoney(0, ' ', ' ') : value,
                            width: this.getSettingViewCountWeight[p]
                        });
                    }
                }

                return result.reverse();
            },

            childrenCount(){
                if(this.isFolder){
                    return " (" + this.model.total_flatten + ")"
                }

                return "";
            },
            isSelected() {
                return this.isNodeSelect();
            },
        },
        methods: {
            setNodesInfo(nodeInfo) {
                this.store.mutations.setNodesInfo(nodeInfo);
            },
            setSelectNode(node) {
                this.store.mutations.setSelectNode(node);
            },
            setSelectNodes(model) {
                this.store.mutations.setSelectNodes(model);
            },
            setSelectNodesById(id) {
                this.store.mutations.setSelectNodesById(id);
            },
            deleteSelectNodesById(id) {
                this.store.mutations.deleteSelectNodesById(id);
            },
            clearSelectNodes() {
                this.store.mutations.clearSelectNodes();
            },
            isNodeSelect(){
                return this.getSelectNode.id === this.model.id
                || (this.getSelectNodes.length > 0 && findIndex(this.getSelectNodes, {id: this.model.id}) !== -1);
            },
            toggle(){
                if (this.isFolder) {
                    let self = this;
                    let targetNode = this.tree.getNodeById(this.model.id);
                    this.tree.toggleNode(targetNode, {
                        asyncCallback(){
                            self.setNodesInfo(self.tree.getNodesInfo());
                        }
                    });

                }
            },

            onContextMenu: function (el) {
                this.onNodeRightClick({
                    model: this.model,
                    el: el
                });
            },

            handleItemClick (e) {

                if(e.target && e.target.className && e.target.className.indexOf('fa-chevron') > 0){
                    return false;
                }

                if(e.ctrlKey || e.metaKey){

                    if(this.model.id === 0 || this.model.id === -1 || this.model.id === -2 || this.model.id === -3){
                        return false;
                    }

                    if (this.model.id === this.getSelectNode.id) {
                        this.setSelectNode({});
                        this.deleteSelectNodesById(this.model.id);
                        return false;
                    }

                    this.setSelectNodes(this.model);

                    if (
                        Object.keys(this.getSelectNode).length !== 0
                        && findIndex(this.getSelectNodes, {id: this.getSelectNode.id}) === -1
                    ) {
                        this.setSelectNodes(this.getSelectNode);
                    }

                } else if(e.shiftKey) {

                    if(this.model.id === 0 || this.model.id === -1 || this.model.id === -2 || this.model.id === -3){
                        return false;
                    }

                    if(!Object.keys(this.getSelectNode).length){

                        this.clearSelectNodes();
                        this.setSelectNode(this.model);
                        this.onNodeClick(this.model);

                    }else{

                        this.clearSelectNodes();

                        let from = this.getNodeIds.indexOf(this.getSelectNode.id),
                            to = this.getNodeIds.indexOf(this.model.id),
                            self = this, index = [];

                        if(to < from){
                            index.push(to);
                            index.push(from);
                        }else{
                            index.push(from);
                            index.push(to);
                            self.setSelectNodesById(this.model.id);
                        }

                        this.getNodeIds.slice(index[0], index[1]).forEach((id) => {
                            if(id !== 0 && id !== -1 && id !== -2 && id !== -3){
                                self.setSelectNodesById(id);
                            }
                        });

                    }

                }else{

                    this.clearSelectNodes();
                    this.setSelectNode(this.model);
                    this.onNodeClick(this.model);

                }

            },

            handleItemMouseOver () {
                this.isHover = true;
            },

            handleItemMouseOut () {
                this.isHover = false;
            },
            highlight(value){
                if(!this.filter){
                    return value;
                }

                let pattern = "(" + this.filter.split("+").map((item) => {return item.trim()}).join("|") + ")",

                    result = this.filter.split("+").every((q) => {
                        return value.toLowerCase().indexOf(q.toLowerCase().trim()) >= 0;
                    });

                if(!result){
                    return value;
                }

                return value.replace(new RegExp(pattern, 'gi'), '<span style="background-color: #338fff; color: #fff">' + '$&' + '</span>');
            },

            moveKeys(keys) {
                this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);

                let self = this,
                    targetNode = this.tree.getNodeById(this.model.id),
                    fromNode = this.tree.getNodeById(this.getSelectNode.id);

                axios({
                    method: 'post',
                    url: this.apiUrl+ '/' + this.model.id + '/keywords',
                    withCredentials: true,
                    data: {ids: keys, to: this.model.id, from: this.getSelectNode.id}
                })
                    .then(function (response) {
                        if (fromNode.id === self.getConstants.clusterResultId) {
                            self.$emitter.emit(Listeners.CLUSTER_TREE_RELOAD);
                        } else {
                            self.tree.updateNode(targetNode, response.data.to);
                            self.tree.updateNode(fromNode, response.data.from);
                        }

                        self.tree.sortByField(targetNode.getParent(), self.getSetting.sort);

                        if(targetNode.getParent().id !== fromNode.getParent().id){

                            self.tree.sortByField(fromNode.getParent(), self.getSetting.sort);

                        }

                        self.setNodesInfo(self.tree.getNodesInfo());

                        self.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                        self.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
                    })
                    .catch(function (error) {
                        self.$snotify.error(error.response.data.message, {
                            timeout: 5000,
                            showProgressBar: false,
                        });
                    })
                    .finally(() => {
                        this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
                    });

            },

            emptyTrash(e) {
                e.preventDefault();
                this.$emitter.emit(Listeners.CLUSTER_EMPTY_TRASH);
            },

            moveNode(to, nodes = null) {
                let self = this,
                    fromIds = [],
                    targetNode = this.tree.getNodeById(to);

                let moveNodes = nodes ? nodes : this.getSelectNodes;

                moveNodes.forEach((n) => {
                    if(n.id !== 0 && n.id && -1 && n.id !== -2 && n.id !== -3){
                        let node = this.tree.getNodeById(n.id);
                        let result = this.tree.moveNodeTo(node, targetNode);
                        if(result){
                            fromIds.push(n.id);
                        }

                    }
                });

                this.tree.sortByField(targetNode, this.getSetting.sort);

                if(targetNode.state.open){
                    self.setNodesInfo(self.tree.getNodesInfo());
                }else{
                    this.tree.openNode(targetNode, {
                        asyncCallback(){
                            self.setNodesInfo(self.tree.getNodesInfo());
                        }
                    });

                }

                if(fromIds.length === 0){
                    return false;
                }

                this.clearSelectNodes();

                axios({
                    method: 'patch',
                    url: this.apiUrl,
                    withCredentials: true,
                    data: {ids: fromIds, pid: to}
                })
                .then(function (response) {
                }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                })

            },
            update(){

                let node = this.tree.getNodeById(this.model.id),
                    self = this;

                this.tree.updateNode(node, {name: this.name});

                this.tree.sortByField(node.getParent(), this.getSetting.sort);

                this.setNodesInfo(this.tree.getNodesInfo());

                this.isEdit = false;

                axios({
                    method: 'patch',
                    url: this.apiUrl,
                    withCredentials: true,
                    data: {id: this.model.id, name: node.name}
                })
                .then(function (response) {

                }).catch(function (error) {

                    self.$snotify.error(error.response.data.message, {
                        timeout: 5000,
                        showProgressBar: false,
                    });

                })


            },
            handleDropped() {
                const fid = this.store.getters.dragStartFolderId();
                // если было событие вызвано внутри данного компонента и определен ID перетягиваемой ноды (папки)
                if (fid) {
                    const node = this.tree.getNodeById(fid);
                    if (this.model.id === -2 || this.model.id === -1) {
                        this.$emitter.emit(Listeners.CLUSTER_DELETE_NODE, {model: [node], targetNode: this.model.id});
                        return false;
                    }

                    this.moveNode(this.model.id, [node]);
                } else {
                    // иначе событие прилетело извне
                    const keys = this.$parent.$parent.$parent.$refs.ksTable.selectedTo;
                    // если есть выбранные чекбоксы ключевых слов
                    if (keys) {
                        this.moveKeys(keys);
                    }
                }

                this.isDragOver = false;
            },
            handleDragEndFolder() {
                this.store.mutations.setDragStartFolderId(null);
            },
            handleDragStartFolder(folderId) {
                this.store.mutations.setDragStartFolderId(folderId);
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },
        },
        mounted() {
            this.$emitter.on(Listeners.CLUSTER_UPDATE_NODE, model => {
                if(this.model.id === model.id){
                    this.isEdit = true;
                }
            });

            this.$emitter.on(Listeners.CLUSTER_MOVE_NODE, ({to, nodes}) => {
                if(this.model.id === to){
                    this.moveNode(to, nodes);
                }
            });

            this.$emitter.on(Listeners.CLUSTER_UNSET_LOCK_NODE, model => {

                if(this.model.id === model.id){
                    let fromNode = this.tree.getNodeById(model.id)
                        /*flattenNode = this.tree.flattenNode(fromNode)*/;

                    this.tree.updateNode(fromNode, {lock: false});
                    this.setNodesInfo(this.tree.getNodesInfo());
                }
            });

            this.$emitter.on(Listeners.CLUSTER_SET_LOCK_NODE, model => {
                if(this.model.id === model.id){
                    let fromNode = this.tree.getNodeById(model.id)
                        /*flattenNode = this.tree.flattenNode(fromNode)*/;

                    this.tree.updateNode(fromNode, {lock: true});
                    this.setNodesInfo(this.tree.getNodesInfo());
                }
            });

            this.$emitter.on(Listeners.CLUSTER_TOUR_SET_NODE, model => {
                if((Object.keys(this.getSelectNode).length === 0 || this.getSelectNode.id === 0) && this.model.id === -1){

                    this.clearSelectNodes();
                    this.setSelectNode(this.model);
                    this.onNodeClick(this.model);

                }
            });

        },
        created () {
            const events = {
                'mouseover': this.handleItemMouseOver,
                'mouseout': this.handleItemMouseOut,
            };
            this.events = events
        },
        watch: {
            isEdit(newVal, oldVal) {
                if (oldVal === true && newVal === false) {
                    this.clickListener.stop();
                    this.name = null;
                }
                if (oldVal === false && newVal === true) {
                    this.clickListener.start();
                    this.name = this.model.name;
                    let self = this;
                    nextTick(() => {
                        self.$refs.editInput.focus();
                        self.$refs.editInput.select();
                    });
                }
            },

        },

        components: { Drag, Drop }
    }
</script>
<template>
<div
    @drop.prevent="handleDropped"
    @dragenter.prevent
    @dragover.prevent="this.isDragOver = true"
    @dragleave.prevent="this.isDragOver = false"
    :draggable="isDraggable"
    @dragstart="handleDragStartFolder(model.id)"
    @dragend="handleDragEndFolder"
>
    <div @click="handleItemClick" @click.right.prevent="onContextMenu">
        <div :style="{'margin-left': model.state.depth * 12 + 'px'}" v-on="events" :title="model.name" :class="{'tree-node-drag-over': isDragOver, 'tree-node-select': isSelected}" class="tree_node__container">
            <i v-if="isFolder" :class="chevronClasses" @click.prevent="toggle" aria-hidden="true" style="padding-right: 5px;"></i>
            <span v-if="!isFolder" style="padding-right: 12px;">&nbsp;</span>
            <span v-if="!isFolder"><i :class="isNotFolderClasses" style="padding-right: 5px;" aria-hidden="true"></i></span>
            <span v-if="isFolder" :class="folderClasses" style="padding-right: 5px;"></span>
            <span v-if="!isEdit">
                <span v-html="highlight(model.name) + childrenCount"></span>
                <i class="fa fa-lock" v-if="isLock" aria-hidden="true"></i>

                <div v-if="model.id !== 0 && model.id !== -3" style="float: right; background: white; position: absolute; top: 1px; right: 0;">
                    <a v-if="model.id === -2 && model.keys_count > 0" class="art-link" href="#" @click="emptyTrash">{{this.$t('lang.main.btn.clear')}}</a>
                    <span v-for="info in labelInfo" :style="{'width': info.width + 'px', 'color': info.color, 'background-color': info.background}" style="float: right;">
                        <span class="tree-node-info">{{info.value}}</span>
                    </span>
                </div>
            </span>
            <input ref="editInput" v-if="isEdit" type="text" style="width: 100%" v-model="name" @keyup.enter="update" />
        </div>
    </div>
</div>
</template>

<style scoped>
    .tree_node__container {
        display: flex;
        align-items: center
    }
    .tree_node__container > span {
        max-width: 250px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .tree-node {
        transition: background-color .15s, box-shadow .15s;
        cursor: default;
        padding-left: 5px;
        background: transparent;
        border: 1px solid transparent;
    }

    .tree-node-info {
        display: block;
        margin: 0 5px 0 0;
        font-size: 8px;
        text-align: right;
    }

    .tree-node-hovered {
        background: #fafbfc;
    }

    .tree-node-select {
        background: #fafbfc;
        border: 1px solid #e8edf1;
    }

    .tree-node-drag-over {
        border: 1px dashed #d4d4db;
    }

    .art-link {
        margin-right: 10px;
        font-size: 12px;
    }

    i {
        margin-left: 5px;
    }
</style>
